/* ============
 * License Group Transformer
 * ============
 *
 * The transformer for the license.
 */

import Transformer from './transformer';
import licensePermitGroupTransformer from './licensePermitGroup';

export default class licenseTransformer extends Transformer {

  static fetch(license) {
    return {
      id: license.id,
      organizationNumber: license.organization_number,
      ownerOrganizationNumber: license.owner_organization_number,
      licenseTypeId: license.license_type_id,
      licenseType: license.license_type,
      licensePermitTypeId: license.license_permit_type_id,
      licensePermitType: license.license_permit_type,
      licenseNumber: license.license_number,
      name: license.name,
      streetName: license.street_name,
      postalCode: license.postal_code,
      city: license.city,
      municipality: license.municipality,
      municipalityNumber: license.municipality_number,
      validFrom: license.valid_from,
      validTo: license.valid_to,
      licensePermitGroups: license.license_permit_groups ? licensePermitGroupTransformer.fetchCollection(license.license_permit_groups) : [],
      licenseFile: license.license_file || '',
    };
  }

  static send(license) {
    return {
      id: license.id,
      organization_number: license.organizationNumber,
      owner_organization_number: license.ownerOrganizationNumber,
      license_type_id: license.licenseTypeId,
      license_permit_type_id: license.licensePermitTypeId,
      license_group_ids: license.licenseGroupIds,
      license_number: license.licenseNumber,
      name: license.name,
      street_name: license.streetName,
      postal_code: license.postalCode,
      city: license.city,
      municipality: license.municipality,
      municipality_number: license.municipalityNumber,
      valid_from: license.validFrom,
      valid_to: license.validTo,
      license_file: license.licenseFile && license.licenseFile.file ? license.licenseFile.file : '',
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/license.js